import React, {Component} from 'react';
import classnames from "classnames";
import {Breadcrumb, BreadcrumbItem, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane} from "reactstrap";
import {Link} from "react-router-dom";
import UserPanelMenu from "../../components/user/UserPanelMenu";
import MerchantFormUpdate from "../../components/merchants/MerchantFormUpdate";
import MerchantGalleryUpdate from "../../components/merchants/MerchantGalleryUpdate";
import axios from "axios/index";
import {API_URL} from "../../config/Config";
import PageLoader from "../../components/loader/PageLoader";
import MerchantPackages from "../../components/merchants/MerchantPackages";

export default class UserMerchantEdit extends Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            loading: false,
            activeTab: '1',
            is_enable:true,
            business_id: 0,
            fields: {
                title: '',
                alias: '',
                short_desc:'',
                description: '',
                cover: null,
                phone: '',
                website:'',
                address:'',
                instagram:'',
                telegram:'',
                whatsapp:'',
                postal_code:'',
                state:0,
                city_id:0,
                is_published:false,
                category1:0,
                category2:0,
                cover_image:'',
            },
            images:[]
        };
    }
    async componentDidMount(){
        const { params } = this.props.match;
        let business_id = await params.id;


        if (business_id){
            this.setState({business_id});
            await this.getBussinessObject();
        }
        this.setState({loading:true});
    }

    async getBussinessObject(){

        let response = await axios.get(`${API_URL}business/${this.state.business_id}`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');

        }else{
            let bussiness = response.data.data;
            let images = response.data.data.galleries;
            let categories = bussiness.categories;
            let category1=categories[0].id;
            let category2=categories[1].id;
            if (categories[0].level === 2){
                category1=categories[1].id;
                category2=categories[0].id;
            }
            let fields = {
                title : bussiness.title,
                alias : bussiness.alias,
                short_desc : bussiness.short_desc,
                description : bussiness.description,
                cover : '',
                phone : bussiness.phone,
                website : bussiness.website,
                address : bussiness.address,
                instagram : bussiness.instagram,
                telegram : bussiness.telegram,
                whatsapp : bussiness.whatsapp,
                postal_code : bussiness.postal_code,
                state : '',
                city_id : parseInt(bussiness.city_id,10),
                is_published : parseInt(bussiness.is_published,10),
                category1,
                category2,
                cover_image:  bussiness.cover,
            };
            this.setState({fields,images});
        }
    }


    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
    render() {
        return (
            <div className="pt-3">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">کاربر</Link></BreadcrumbItem>
                        <BreadcrumbItem active> صفحه کاربری</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12' className="">
                            <UserPanelMenu activeElement="3"/>
                        </Col>
                        <Col md='9' sm='12'>
                            {!this.state.loading ? <PageLoader type="bubbles" color="#4fbfa8"/> :
                                <div className="panel panel-default white">
                                    <div className="portlet-title">
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({active: this.state.activeTab === '1'})}
                                                    onClick={() => {
                                                        this.toggle('1');
                                                    }}
                                                >
                                                    اطلاعات پایه
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({active: this.state.activeTab === '2'})}
                                                    onClick={() => {
                                                        this.toggle('2');
                                                    }}
                                                    disabled={!this.state.is_enable}
                                                >
                                                    گالری تصاویر
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({active: this.state.activeTab === '3'})}
                                                    onClick={() => {
                                                        this.toggle('3');
                                                    }}
                                                    disabled={!this.state.is_enable}
                                                >
                                                    خرید بسته و فعال سازی
                                                </NavLink>
                                            </NavItem>

                                        </Nav>
                                    </div>
                                    <div className="portlet-body p-3">
                                        <TabContent activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">
                                                <MerchantFormUpdate id={this.state.business_id}
                                                                    fields={this.state.fields}/>
                                            </TabPane>
                                            <TabPane tabId="2">
                                                <MerchantGalleryUpdate id={this.state.business_id}
                                                                       images={this.state.images}/>
                                            </TabPane>
                                            <TabPane tabId="3">
                                                <MerchantPackages id={this.state.business_id}/>
                                            </TabPane>

                                        </TabContent>
                                    </div>
                                </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/UserMerchantEdit.js